// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Maintenance_wrapper__gt3Pj","content":"Maintenance_content__Qqb8I","copyright":"Maintenance_copyright__X9AL4"};